<template>
	<div>
		<div style="width: 100%;">
			<el-button type="primary" @click="addTypeDialog">新建类型</el-button>
		</div>
		<div style="margin-top: 25px;width: 100%;">
			<el-row :gutter="20">
				<el-col :span="8" v-for="item in agentType">
					<el-card shadow="hover" :body-style="{color:'white',backgroundColor:item.color}" style="text-align: center;width: 300px;margin-top: 10px;">
				      	<div>
				      		<div style="width: 95%;text-align: right;line-height: 20px;">
				      			<i @click="updateTypeDialog(item)" class="el-icon-edit iconClass"></i>
				      			<span @click="frozType(item.categoryId)" v-if="item.freeze === 0" style="border: 1px solid #ffffff;cursor:pointer;font-size: 10px;color: #ffffff;margin-right: 12px;vertical-align:middle;">冻结</span>
				      			<span @click="unFrozType(item.categoryId)" v-if="item.freeze === 1" style="border: 1px solid #fb5353;cursor:pointer;font-size: 10px;color: #fb5353;margin-right: 12px;vertical-align:middle;">解冻</span>
				      			<i @click="delType(item)" class="el-icon-close iconClass"></i>
				      		</div>
				      	</div>
				      <!--	<div style="font-size: 18px;margin-top: 20px;">
				      		<span v-if="item.level === 3">一级代理商</span>
                            <span v-if="item.level === 2">二级代理商</span>
                            <span v-if="item.level === 8">三级代理商</span>
				      	</div>-->
				      	<div style="font-size: 20px;margin-top: 25px;">
				      		{{item.name}}
				      	</div>
				      	<!--<div style="font-size: 15px;margin-top: 25px;">
				      		招商奖励分成:{{item.divide}}%
				      	</div>-->
				      	<div style="font-size: 15px;margin-top: 15px;">
				      		首次最低货款:{{item.initialFunding}}元
				      	</div>
				      	<hr style="FILTER: alpha(opacity=100,finishopacity=0,style=3)" width="100%" color=#ffffff SIZE=3/>
				      	<div style="font-size: 13px;margin-top: 30px;margin-bottom: 15px;">
				      		说明:{{item.description}}
				      	</div>
				    </el-card>
				</el-col>
			</el-row>
			<el-pagination background
	    		style="text-align:center;margin-top: 24px;margin-bottom: 55px;"
			    @size-change="handleSizeChange"
			    @current-change="handleCurrentChange"
			    :current-page="currentPage"
			    :page-sizes="[10, 50, 100, 200]"
			    :page-size="pageSize"
			    layout="total, sizes, prev, pager, next, jumper"
			    :total="total">
			</el-pagination>
		</div>
		<el-dialog :title="title" :visible.sync="myDialog" :close-on-click-modal="false">
			<el-form label-position="right" label-width="120px" ref="agentTypeForm" :rules="agentTypeRules" :model="agentTypeForm">
				<!--<el-form-item label="级别" prop="level" v-if="addType">
    				<el-select v-model="agentTypeForm.level" style="width: 180px;">
						<el-option value="3" label="一级代理商"></el-option>
						<el-option value="2" label="二级代理商"></el-option>
                        <el-option value="8" label="三级代理商"></el-option>
					</el-select>
  				</el-form-item>-->
  		<!--		<el-form-item label="级别" prop="level" v-if="updateType">
    				<span v-if="agentTypeForm.level == 3">一级代理商</span>
    				<span v-if="agentTypeForm.level == 2">二级代理商</span>
					<span v-if="agentTypeForm.level == 8">三级代理商</span>
  				</el-form-item>-->
  				<el-form-item label="名称" prop="name">
    				<el-input v-model="agentTypeForm.name" type="text" style="width: 180px;"></el-input>
  				</el-form-item>
  				<el-popover
				    ref="popover"
				    placement="top"
				    width="222"
				    trigger="focus"
				    :content="initMoney">
				</el-popover>
  				<el-form-item label="首次最低货款" prop="initialFunding">
    				<el-input v-model="agentTypeForm.initialFunding" type="text" style="width: 180px;" v-popover:popover></el-input>
  				</el-form-item>
  				<el-form-item label="招商奖励" prop="divide" v-if="agentTypeForm.level == '3'||agentTypeForm.level == '2'">
    				<el-input v-model="agentTypeForm.divide" type="text" style="width: 180px;">
    					<template slot="append">%</template>
    				</el-input>
  				</el-form-item>
  				<el-form-item label="描述" prop="description">
    				<el-input v-model="agentTypeForm.description" type="textarea" :rows="3" style="width: 180px;"></el-input>
  				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" v-if="addType" @click="newAgentType">新建</el-button>
				<el-button type="primary" v-if="updateType" @click="updateAgentType">修改</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'agentTypeSet',
  components: {
  },
  data() {
  	var validMoney = (rule, value, callback) => {
  		var regPos = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;
		var temp = (value.toString().indexOf(".")!=-1)?value.toString().substring(0,value.toString().indexOf(".")):value;
		if(temp.length >= 10){
			callback(new Error('输入金额不应大于10亿!'));
		}else if(value <= 0){
			callback(new Error('输入金额应大于0元!'));
		}else if((value.toString().charAt(0) == '0' && value.toString().indexOf(".") != 1)  || !regPos.test(value) || value.toString().indexOf(".") == value.length-1){
			callback(new Error('请输入正确格式的金额!金额最多保留两位小数.'));
		}else{
			callback();
		}
	}
  	var validDivide = (rule, value, callback) => {
  		var regPos = /^-?\d+$/;
		if(!regPos.test(value)){
			callback(new Error('输入招商奖励比例只能为整数!'));
		}else if(value < 0 || value >= 100){
			callback(new Error('招商奖励比例应大于等于0且小于100!'));
		}else{
			callback();
		}
	}
    return {
    	agentType:[],
    	myDialog:false,
    	total: 0,
      	currentPage: 1,
　　  	pageSize: 10,
		addType: false,
		updateType:false,
		title:'',
		categoryId:'',
    	agentTypeForm:{
    		level:"",
    		description:"",
    		initialFunding:"",
    		name:"",
    		divide:''
    	},
    	agentTypeRules:{
    		level:[{ trigger: 'change',required: true, message: '请选择代理商级别!'}],
    		description:[{ trigger: 'blur',required: true, message: '描述不能为空!'}],
    		initialFunding:[{ trigger: 'blur',required: true, message: '首次最低货款不能为空!'},
    					{ trigger: 'blur',validator: validMoney}],
    		name:[{ trigger: 'blur',required: true, message: '名称不能为空!'}],
    		divide:[{ trigger: 'blur',required: true, message: '招商奖励比例不能为空!'},
    					{ trigger: 'blur',validator: validDivide}]
    	}
    }
  },
  watch: {
  },
  computed:{
  	initMoney:function(){
  		var money = "0.00";
  		var regPos = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;
  		if(this.agentTypeForm.initialFunding != ""){
  			if(regPos.test(this.agentTypeForm.initialFunding)){
  				var intPart = Number(Math.floor(this.agentTypeForm.initialFunding));
  				var valueArray = this.agentTypeForm.initialFunding.toString().split(".");
  				if(intPart.toString().length < 10){
  					if(valueArray.length == 2){
	  					var floatPart = valueArray[1].toString();
	  					if(floatPart.length == 1){
	  						money = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + "." + floatPart + "0";
	  					}else if(floatPart.length == 2){
	  						money = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + "." + floatPart;
	  					}else{
				  			return "您输入的金额格式有误!"
				  		}
	  				}else{
	  					money = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + ".00";
	  				}
  				}else{
		  			return "您输入的金额格式有误!"
		  		}
  			}else{
	  			return "您输入的金额格式有误!"
	  		}
  		}
  		return "您输入金额:"+money+"元";
  	}
  },
  mounted() {
  	this.updateTable();
  },
  beforeDestroy() {
  },
  methods: {
  	addTypeDialog(){
  		this.title = "新增类型";
  		this.agentTypeForm.level = "";
  		this.agentTypeForm.name = "";
  		this.agentTypeForm.initialFunding = "";
  		this.agentTypeForm.divide = "";
  		this.agentTypeForm.description = "";
  		this.categoryId = "";
  		this.myDialog = true;
  		this.addType = true;
  		this.updateType = false;
  	},
  	updateTypeDialog(item){
  		if(item.freeze){
  			this.$message.error("代理商类型已冻结，无法进行修改！");
  		}else{
  			this.title = "修改类型";
	  		this.agentTypeForm.level = item.level+"";
	  		this.agentTypeForm.name = item.name;
	  		this.agentTypeForm.initialFunding = item.initialFunding;
	  		this.agentTypeForm.description = item.description;
	  		this.agentTypeForm.divide = item.divide;
	  		this.categoryId = item.categoryId;
	  		this.myDialog = true;
	  		this.updateType = true;
	  		this.addType = false;
  		}
  	},
  	newAgentType(){
  		var thiz = this;
  		this.$refs["agentTypeForm"].validate(async valid => {
	        if (valid) {
	        	var params = {
					  	description:this.agentTypeForm.description,
					  	initialFunding:this.agentTypeForm.initialFunding,
					  	level:9,
					  	name:this.agentTypeForm.name,
              isOperator:1
					};
				if(this.agentTypeForm.level == '3'||this.agentTypeForm.level=='2'){
					params.divide = this.agentTypeForm.divide;
				}else{
					params.divide = 0;
				}
			  	axios.get(this.$store.getters.getApiValue+'/srsAgentCategory/addAgentCategory.do',{
					params:params
				}).then(function (response) {
					var data = response.data;
					if(data.status == "200"){
						thiz.$message.success("新增成功!");
						thiz.updateTable();
						thiz.myDialog = false;
					}else{
						thiz.$message.error(data.message);
					}
				}).catch(function (error) {
					console.log(error);
					thiz.$message.error("系统异常!请与管理员联系!");
				});
	        } else {
	          this.$message.error("填写不完整或格式不正确，请确认！")
	        }
      	})
  	},
  	handleSizeChange(val) {
      this.pageSize = val;
      this.updateTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updateTable();
    },
    updateTable(){
    	var thiz = this;
    	const loading = this.$loading({
          lock: true,
          text: '导入表格数据中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
	  	axios.get(this.$store.getters.getApiValue+'/srsAgentCategory/getAgentCategory.do',{
			params:{
          isOperator:1,
			  	pageId:thiz.currentPage,
  				size:thiz.pageSize
			}
		}).then(function (response) {
			loading.close();
			var data = response.data;
			if(data.status == "200"){
				thiz.agentType = data.data;
				thiz.total = data.totalCount;
			}else{
				thiz.$message.error(data.message);
			}
		}).catch(function (error) {
			loading.close();
			console.log(error);
			thiz.$message.error("系统异常!请与管理员联系!");
		});
   },
   updateAgentType(){
   		var thiz = this;
  		this.$refs["agentTypeForm"].validate(async valid => {
	        if (valid) {
	        	var params = {
						categoryId:this.categoryId,
					  	description:this.agentTypeForm.description,
					  	initialFunding:this.agentTypeForm.initialFunding,
					  	level:9,
					  	name:this.agentTypeForm.name
					};
				if(this.agentTypeForm.level == '3'){
					params.divide = this.agentTypeForm.divide;
				}else{
					params.divide = 0;
				}
			  	axios.get(this.$store.getters.getApiValue+'/srsAgentCategory/updateAgentCategory.do',{
					params:params
				}).then(function (response) {
					var data = response.data;
					if(data.status == "200"){
						thiz.$message.success("修改成功!");
						thiz.updateTable();
						thiz.myDialog = false;
					}else{
						thiz.$message.error(data.message);
					}
				}).catch(function (error) {
					console.log(error);
					thiz.$message.error("系统异常!请与管理员联系!");
				});
	        } else {
	          this.$message.error("填写不完整或格式不正确，请确认！")
	        }
      	})
  	},
  	frozType(categoryId){
  		var thiz = this;
	  	axios.get(this.$store.getters.getApiValue+'/srsAgentCategory/freezeAgentCategory.do',{
			params:{
				categoryId:categoryId
			}
		}).then(function (response) {
			var data = response.data;
			if(data.status == "200"){
				thiz.$message.success("冻结成功");
				thiz.updateTable();
			}else{
				thiz.$message.error(data.message);
			}
		}).catch(function (error) {
			console.log(error);
			thiz.$message.error("系统异常!请与管理员联系!");
		});
  	},
  	unFrozType(categoryId){
  		var thiz = this;
	  	axios.get(this.$store.getters.getApiValue+'/srsAgentCategory/unfreezeAgentCategory.do',{
			params:{
				categoryId:categoryId
			}
		}).then(function (response) {
			var data = response.data;
			if(data.status == "200"){
				thiz.$message.success("解冻成功");
				thiz.updateTable();
			}else{
				thiz.$message.error(data.message);
			}
		}).catch(function (error) {
			console.log(error);
			thiz.$message.error("系统异常!请与管理员联系!");
		});
  },
  	delType(item){
  		var thiz = this;
  		this.$confirm('确认删除名为“'+item.name+'”代理商类型吗?')
  			.then(_ => {
	        	axios.get(thiz.$store.getters.getApiValue+'/srsAgentCategory/delAgentCategory.do',{
					params:{
						categoryId:item.categoryId
					}
				}).then(function (response) {
					var data = response.data;
					if(data.status == "200"){
						if(data.data){
							thiz.$message.success("删除成功");
						}else{
							thiz.$message.error("此代理商类型正在被使用中，无法删除!");
						}
						thiz.updateTable();
					}else{
						thiz.$message.error(data.message);
					}
				}).catch(function (error) {
					console.log(error);
					thiz.$message.error("系统异常!请与管理员联系!");
				});
			}).catch(_ => {});
  	}
  }
}
</script>

<style>
.iconClass{
	font-size: 16px;
	margin-right: 12px;
	vertical-align:middle;
	cursor:pointer;
}
</style>
